import { mapGetters, mapActions } from "vuex";
import { getAddressFields } from "../../../api/helpers/commonHelpers";
import { getCurrentDate } from "../../../api/helpers/datetimeHelper";
export default {
  computed: {
    ...mapGetters([
      "addressOutOfService",
      "getDeliveryIsLoading",
      "deliveryAddress",
      "currentStoreDoc",
    ]),
  },
  methods: {
    ...mapActions(["applyDeliveryAddress"]),
    async updateAddress() {
      const now = new getCurrentDate(
        this.currentStoreDoc.TimezoneIanaFormat
      ).toJSDate();
      await this.applyDeliveryAddress({
        address: this.toModel(),
        scheduledTime: now.toISOString(),
        isUpdateDeliverAddress: true,
      });
    },
    toModel() {
      return getAddressFields(this.location);
    },
  },
};
